import { hotPicks } from "@/mocks/trends";

export default function HotPicks() {
  return (
    <section id="hotpick" className="w-full scroll-mt-20 bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
              <i className="ri-fire-line"></i> 爆款瓜料
            </span>
            <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">今日最热瓜料合集</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">深度还原每个话题的来龙去脉，吃透每一个瓜</p>
          </div>
          <a
            href="#ranking"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("ranking")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-500"
          >
            返回热度榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {hotPicks.map((p, i) => (
            <article
              key={p.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:-translate-y-1"
            >
              <div className="relative overflow-hidden">
                <img
                  src={p.image}
                  alt={`${p.title}配图`}
                  className="h-44 w-full object-cover transition duration-500 group-hover:scale-105 md:h-48"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-400/90 px-2.5 py-1 text-[10px] font-bold text-foreground-950">
                  瓜料 {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <span className="inline-flex self-start rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800">
                  {p.category}
                </span>
                <h4 className="mt-2 text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {p.title}
                </h4>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{p.excerpt}</p>
                <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {p.readCount}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i> {p.discussCount}
                    </span>
                  </div>
                  <span className="whitespace-nowrap">{p.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}